module.exports = __webpack_public_path__ + "img/mediastats-white.a8bee5bc.svg";